import React from 'react'
import { Stake, StakeProvider } from '@/page-components/Stake'
import { WithdrawModalProvider } from '@/page-components/Stake/WithdrawModal'
import { StakeFeeTokensModalProvider } from '@/page-components/Stake/StakeFeeTokensModal'
import { ReferralProvider } from '@/page-components/Stake/Referral'

export default function Home() {
  return (
    <ReferralProvider>
      <StakeProvider>
        <StakeFeeTokensModalProvider>
          <WithdrawModalProvider>
            <Stake />
          </WithdrawModalProvider>
        </StakeFeeTokensModalProvider>
      </StakeProvider>
    </ReferralProvider>
  )
}
